export default __webpack_public_path__ + "static/media/wd.307d67e9.png";